__turbopack_context__.v({
  "action__button": "FilterModal-module__1MMbZa__action__button",
  "active": "FilterModal-module__1MMbZa__active",
  "blok-big-title": "FilterModal-module__1MMbZa__blok-big-title",
  "blok-subtitle": "FilterModal-module__1MMbZa__blok-subtitle",
  "blok-title": "FilterModal-module__1MMbZa__blok-title",
  "flex-wrapper": "FilterModal-module__1MMbZa__flex-wrapper",
  "mobile-header": "FilterModal-module__1MMbZa__mobile-header",
  "mobile-overlay": "FilterModal-module__1MMbZa__mobile-overlay",
  "mobile__modal-buttons": "FilterModal-module__1MMbZa__mobile__modal-buttons",
  "modal-sections-wrapper": "FilterModal-module__1MMbZa__modal-sections-wrapper",
  "portal": "FilterModal-module__1MMbZa__portal",
  "portal__element": "FilterModal-module__1MMbZa__portal__element",
  "portal_closing-button": "FilterModal-module__1MMbZa__portal_closing-button",
  "search-bar__wrapper": "FilterModal-module__1MMbZa__search-bar__wrapper",
});
